<div class="prescription-checks-container">
  @for (check of prescriptionSolutionStruct.listSolutionCheck; track check) {
    <button
      mat-flat-button color="accent"
      (click)="onClickInPrescriptionCheck(check)"
      class="btn-block prescription-check-button">
      <span>
        {{ check.prescriptionSolutionCheck.idStatusScheduling === statusSchedulingEnum.Suspenso ? '🔴' : check.prescriptionSolutionCheck.idStatusScheduling === statusSchedulingEnum.Concluido ? '🟢' : '' }}
      </span>
      Data e hora aprazadada: <b>{{ check.prescriptionSolutionCheck.datetimeCheckEstimative | date: 'dd/MM/yyyy' }}, {{ check.prescriptionSolutionCheck.datetimeCheckEstimative | date: 'HH:mm' }}</b>
    </button>
  }
</div>
